let server = '',
    // eslint-disable-next-line prefer-const
    base = window.location.origin + '/',
    helpUrl = '',
    // eslint-disable-next-line prefer-const
    downloadUrl = '/attach/download?path=',
    mainUrl = `${window.location.protocol}//${window.location.hostname}`;
const env = window.VUE_APP_ENV || process.env.VUE_APP_ENV;
switch (env) {
    case 'local':
        server = 'https://sfelx.31scm.com/api/';
        // server = 'http://192.168.0.193:9003/api/';
        mainUrl = '';
        break;
    case 'test':
        server = 'http://testetc.31scm.com/api/';
        helpUrl = '';
        mainUrl = '';
        break;
    case 'pro':
        server = '/api/';
        helpUrl = '';
        mainUrl = '';
        break;
}

export const prefixUrl = downloadUrl;

export default {
    base,
    server,
    helpUrl,
    mainUrl,
};
